import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20250416-qseh",
        datum: "16.04.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "<em>meineQSEH</em>: Organisator beim Kurs hinterlegen",
        lizenz: [LizenzEnum.KURSE],
        content: [
            "Die QSEH fordert bei der Kursmeldung die Nennung einer Ansprechperson (Organisator) vor Ort."
            + " Bisher wurde diese standardmäßig beim Kursort hinterlegt."
            + " Ab sofort kann der „Organisator vor Ort“ je Kurs angegeben werden."
            + " Dies sorgt für Klarheit, bspw. wenn an einem Kursort mehrere Personen für unterschiedliche Fachbereiche tätig sind.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/?p=11037",
            },
        ],
    },
];

export {
    insights,
};
